import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { AIPreferencePageSerializer } from '../../../models/ai-preference-page/ai-preference-page-serializer.class';
import { AIPreferencePage } from '../../../models/ai-preference-page/ai-preference-page.model'
import { AIReportResponse } from "../../../models/ai-report-response/ai-report-response.model";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";


@Injectable()
export class AIPreferencePageService extends BaseApiService<AIPreferencePage> {
    constructor(httpClient: HttpClient) {
        super(
            httpClient,
            null,
            "preferencepages",
            new AIPreferencePageSerializer(),
            new CustomErrorHandlerService());
    }

    // Method to get the HTML content for viewing in a new tab
 

    generateFromPrompt(prompt: string): Observable<AIPreferencePage> {
        return this.httpClient.get<AIPreferencePage>(
            `${this.url}/preferencepages/getFromPrompt/${prompt}`
        );
    }

    saveFromAi(preferencePage: AIPreferencePage): Observable<AIPreferencePage> {
        return this.httpClient.post<AIPreferencePage>(
            `${this.url}/preferencepages/saveFromAi`,
            preferencePage
        );
    }

    getFromAi(preferencePage: AIPreferencePage): Observable<AIPreferencePage> {
        return this.httpClient.post<AIPreferencePage>(
            `${this.url}/preferencepages/query`,
            preferencePage
        );
    }
    getPromptData(prompt: string): Observable<AIReportResponse> {
        return this.httpClient.post<AIReportResponse>(
            `${this.url}/preferencepages/query`,
            { prompt }
        );
    }

}
